(function(){
  if (window.__spBackToResultsInit) return;
  window.__spBackToResultsInit = true;

  var STORAGE_KEY  = 'sp_diamond_results_url';
  var SCROLL_KEY   = 'sp_diamond_results_scroll';
  // v2 suffix: snapshots saved before cards carried data-sd (2026-06-12) restore
  // a grid whose clicks can't instant-fill the PDP — version the key so any
  // pre-fix snapshot is simply ignored instead of replaying the old behavior.
  var SNAPSHOT_KEY = 'sp_diamond_results_snapshot_v2';   // full grid HTML + state
  var SNAPSHOT_TTL_MS = 30 * 60 * 1000;                // 30 minutes

  // Slider → URL param mapping. defaults = [slider min, slider max] that
  // should NOT be written to the URL (so the URL only carries narrowed
  // filters, not the full-range defaults). Grade sliders index into an
  // ordered grade list whose labels the server accepts.
  var SLIDERS = [
    { id: 'diamonds-carat-slider',    keys: ['carat_min','carat_max'],    defaults: [0, 15],    fmt: 'num' },
    { id: 'diamonds-price-slider',    keys: ['price_min','price_max'],    defaults: [0, 25000], fmt: 'num' },
    { id: 'diamonds-color-slider',    keys: ['color_min','color_max'],    defaults: [0, 7],     fmt: 'grade',
      grades: ['K','J','I','H','G','F','E','D'] },
    { id: 'diamonds-clarity-slider',  keys: ['clarity_min','clarity_max'], defaults: [0, 7],    fmt: 'grade',
      grades: ['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'] },
    { id: 'diamonds-cut-slider',      keys: ['cut_min','cut_max'],        defaults: [0, 3],     fmt: 'grade',
      grades: ['Good','Very Good','Excellent','Ideal'] },
    { id: 'diamonds-polish-slider',   keys: ['polish_min','polish_max'],  defaults: [0, 3],     fmt: 'grade',
      grades: ['Fair','Good','Very Good','Excellent'] },
    { id: 'diamonds-symmetry-slider', keys: ['symmetry_min','symmetry_max'], defaults: [0, 3],  fmt: 'grade',
      grades: ['Fair','Good','Very Good','Excellent'] },
    { id: 'diamonds-fluorescence-slider', keys: ['fluorescence_min','fluorescence_max'], defaults: [0, 3], fmt: 'grade',
      grades: ['None','Faint','Medium','Strong'] },
    { id: 'diamonds-lw-ratio-slider', keys: ['ratio_min','ratio_max'],    defaults: [0.8, 3],   fmt: 'num' },
    { id: 'diamonds-depth-slider',    keys: ['depth_min','depth_max'],    defaults: [40, 90],   fmt: 'num' },
    { id: 'diamonds-table-slider',    keys: ['table_min','table_max'],    defaults: [40, 90],   fmt: 'num' },
  ];
  var SLIDER_PARAM_SET = SLIDERS.reduce(function(set, s){ set[s.keys[0]] = true; set[s.keys[1]] = true; return set; }, {});

  function formatNum(n){
    var r = parseFloat(n);
    if (isNaN(r)) return null;
    if (Math.abs(r - Math.round(r)) < 0.001) return String(Math.round(r));
    return r.toFixed(2).replace(/\.?0+$/, '');
  }

  function captureFilterUrl(){
    var params = new URLSearchParams(location.search);
    Object.keys(SLIDER_PARAM_SET).forEach(function(k){ params.delete(k); });
    SLIDERS.forEach(function(s){
      var el = document.getElementById(s.id);
      if (!el || !el.noUiSlider) return;
      var v;
      try { v = el.noUiSlider.get(); } catch(_){ return; }
      if (!Array.isArray(v) || v.length !== 2) return;
      var min = parseFloat(v[0]), max = parseFloat(v[1]);
      if (isNaN(min) || isNaN(max)) return;
      var minOut, maxOut;
      if (s.fmt === 'grade'){
        var iMin = Math.max(0, Math.min(s.grades.length - 1, Math.round(min)));
        var iMax = Math.max(0, Math.min(s.grades.length - 1, Math.round(max)));
        minOut = s.grades[iMin]; maxOut = s.grades[iMax];
      } else {
        minOut = formatNum(min); maxOut = formatNum(max);
      }
      if (min > s.defaults[0] + 0.0001 && minOut != null) params.set(s.keys[0], minOut);
      if (max < s.defaults[1] - 0.0001 && maxOut != null) params.set(s.keys[1], maxOut);
    });
    var q = params.toString();
    return location.pathname + (q ? '?' + q : '');
  }

  function rememberNow(){
    try {
      sessionStorage.setItem(STORAGE_KEY, captureFilterUrl());
      sessionStorage.setItem(SCROLL_KEY, String(Math.round(window.scrollY || window.pageYOffset || 0)));
    } catch(_){}
    // Full grid snapshot: lets the next back-nav hydrate the page instantly
    // without firing the Supabase RPC. Captures rendered HTML + paging state
    // so infinite-scroll resumes from the right page. Also captures the
    // grid's pixel height so the pre-paint restore can reserve layout space
    // before injecting HTML — avoids the y=0 → y=savedY scroll jump.
    try {
      var grid = document.getElementById('sd-grid');
      if (!grid || !grid.innerHTML || grid.innerHTML.length < 100) return;
      var st = window.__sdState || null;
      var snap = {
        path: location.pathname + location.search,
        scrollY: Math.round(window.scrollY || window.pageYOffset || 0),
        gridHTML: grid.innerHTML,
        gridHeight: Math.round(grid.offsetHeight || 0),
        docHeight: Math.round(document.documentElement.scrollHeight || 0),
        page: st && typeof st.page === 'number' ? st.page : 1,
        lastPage: st && typeof st.lastPage === 'number' ? st.lastPage : 1,
        total: st && typeof st.total === 'number' ? st.total : 0,
        totalKnown: !!(st && st.totalKnown),
        ts: Date.now()
      };
      sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snap));
    } catch(_){}
  }

  function isBackForward(){
    try {
      var navEntry = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      if (navEntry && navEntry.type === 'back_forward') return true;
      if (performance.navigation && performance.navigation.type === 2) return true;
    } catch (_) {}
    return false;
  }

  function restoreScrollIfReturning(){
    if (!isBackForward()) return;
    // Template's pre-paint script already handled it — don't fight.
    if (window.__sdSkipBoot) return;
    if (!sessionStorage.getItem(SCROLL_KEY)) return;

    var html = document.documentElement;
    var revealed = false;
    function reveal(){
      if (revealed) return;
      revealed = true;
      try { html.style.visibility = ''; } catch(_) {}
      try { html.style.background = ''; } catch(_) {}
    }

    var y = 0;
    try { y = parseInt(sessionStorage.getItem(SCROLL_KEY) || '0', 10); } catch(_) { y = 0; }
    if (!y || isNaN(y) || y < 1) { reveal(); return; }

    try { history.scrollRestoration = 'manual'; } catch(_) {}

    var attempts = 0;
    var MAX_ATTEMPTS = 50;
    function tryScroll(){
      attempts++;
      var docH = document.documentElement.scrollHeight;
      var winH = window.innerHeight;
      var inBounds = (docH - winH) >= y - 4;
      if (inBounds || attempts > MAX_ATTEMPTS) {
        window.scrollTo({ top: y, left: 0, behavior: 'auto' });
        try { sessionStorage.removeItem(SCROLL_KEY); } catch(_) {}
        requestAnimationFrame(function(){ requestAnimationFrame(reveal); });
        return;
      }
      if (attempts < 20) requestAnimationFrame(tryScroll);
      else setTimeout(tryScroll, 100);
    }
    tryScroll();
  }

  function isDiamondCollection(){
    // 2026-05-20: was a hardcoded regex of 3 paths, which excluded every
    // shape/carat collection that uses the lab-diamonds template
    // (oval-cut-lab-grown-diamonds, 2-carat-lab-grown-diamonds, etc.) and
    // broke scroll-restore on back-nav for those URLs. Check for the
    // template's signature grid element instead — works for any handle.
    return !!document.getElementById('sd-grid');
  }

  function installCollectionCapture(){
    var saveTimer = null;
    function rememberDebounced(){
      clearTimeout(saveTimer);
      saveTimer = setTimeout(rememberNow, 250);
    }
    setTimeout(rememberNow, 1500);
    SLIDERS.forEach(function(s){
      var el = document.getElementById(s.id);
      if (!el || !el.noUiSlider) return;
      try {
        el.noUiSlider.on('change.spBackRemember', rememberDebounced);
        el.noUiSlider.on('set.spBackRemember',    rememberDebounced);
      } catch(_){}
    });
    window.addEventListener('popstate', rememberNow);
    var _push = history.pushState, _replace = history.replaceState;
    history.pushState = function(){ var r = _push.apply(this, arguments); setTimeout(rememberNow, 0); return r; };
    history.replaceState = function(){ var r = _replace.apply(this, arguments); setTimeout(rememberNow, 0); return r; };
    // pagehide is bfcache-compatible; beforeunload disqualifies the page from
    // bfcache in Chrome, which forces a full reload+refetch on back navigation
    // and destroys the "instant back" experience. pagehide fires both when
    // navigating away and when the page is being put INTO bfcache.
    window.addEventListener('pagehide', rememberNow);
    // Multi-layer click capture — Chrome lets us see clicks even if another
    // handler stopPropagations. mousedown fires earlier than click and is
    // harder for libraries to swallow. auxclick handles middle-click.
    function onMaybeNavigate(e){
      var a = e.target && e.target.closest && e.target.closest('a[href*="/products/diamonds"]');
      if (a) rememberNow();
    }
    document.addEventListener('mousedown', onMaybeNavigate, true);
    document.addEventListener('click',     onMaybeNavigate, true);
    document.addEventListener('auxclick',  onMaybeNavigate, true);
    // Touch — mobile back-arrow scenario.
    document.addEventListener('touchstart', onMaybeNavigate, {capture:true, passive:true});

    // Continuously remember scrollY (throttled) so any leave-event — even ones
    // that fire too late to capture the live scroll — has a recent snapshot.
    var lastScrollSave = 0;
    var pendingScrollSave = null;
    window.addEventListener('scroll', function(){
      var now = Date.now();
      if (now - lastScrollSave > 400) {
        lastScrollSave = now;
        rememberNow();
      } else if (!pendingScrollSave) {
        pendingScrollSave = setTimeout(function(){
          pendingScrollSave = null;
          lastScrollSave = Date.now();
          rememberNow();
        }, 400);
      }
    }, {passive:true});

    // visibilitychange fires on tab-hide and on some forms of nav-away that
    // pagehide misses (esp. iOS Safari + some Android Chrome variants).
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'hidden') rememberNow();
    });
  }

  // bfcache fast-path: if the browser restored this page from bfcache, the
  // DOM + scroll position are already intact — nothing to do. Clear the saved
  // scroll key so the slow restore dance doesn't trigger on a later non-bfcache
  // back navigation referencing the wrong Y.
  window.addEventListener('pageshow', function(e){
    if (e && e.persisted) {
      try { sessionStorage.removeItem(SCROLL_KEY); } catch(_){}
      try { sessionStorage.removeItem(SNAPSHOT_KEY); } catch(_){}
      try { document.documentElement.style.visibility = ''; } catch(_){}
    }
  });

  function init(){
    if (!isDiamondCollection()) return;
    restoreScrollIfReturning();
    installCollectionCapture();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
